let candle = [
    {
        id: 0,
        title: "COCOON MUSK",
        imgUrl: "/img/incense6.jpg",
        content: "본능의 향 | 고귀한 머스크 | 성스러운 나무",
        price: 150000
    },

    {
        id: 1,
        title: "MULBERRY LEAVES",
        imgUrl: "/img/incense7.jpg",
        content: "회귀의 향 | 나무껍질의 눈물 | 내적 평온",
        price: 150000
    },

    {
        id: 2,
        title: "SOUNDS OF NIGHT",
        imgUrl: "/img/incense8.jpg",
        content: "씁쓸한 프루티함 | 바람에 흔들리는 꽃의 향 | 고요함",
        price: 150000
    },

    {
        id: 3,
        title: "MIDDLE-EARTH SET",
        imgUrl: "/img/incense9.jpg",
        content: "오더메이드 디퓨저 세트",
        price: 250000
    }
]

export default candle;